export const standards = {
  Add_new_requirement: "Adicionar novo requisito",
  Add_requirement: "Adicionar requisito",
  Add_section: "Adicionar Nova Seção",
  Add_subsection: "Adicionar subseção",
  All_Clients: "Todos os Clientes",
  Content: "Conteúdo",
  Edit_requirement: "Editar requisito",
  Expand_all: "Expandir tudo",
  Full_name: "Nome completo",
  Please_fill_in_the_requirement_information: "Por favor, preencha as informações do requisito",
  Published_date: "Data de publicação",
  Read_less: "Ler menos",
  Read_more: "Ler mais",
  Reference: "Referência",
  Requirement_Info: "Informações do Requisito",
  Section_Reference: "Referência da Seção",
  Section_reference_is_required: "Referência da seção é obrigatória",
  Section_title: "Título da seção",
  Section_title_is_required: "Título da seção é obrigatório",
  Section_with_this_reference_already_exists: "Seção com esta referência e título já existe",
  Sections: "Seções",
  Standard_Body: "Órgão do Padrão",
  Standard_Guidance: "Orientação do Padrão",
  Standard_ID: "ID do Padrão",
  Sub_Section_with_this_title_already_exists: "Subseção com esta referência e título já existe",
  Sub_Sections: "Subseções",
  "Sub-Section_Reference": "Referência da Subseção",
  "Sub-Section_title": "Título da subseção",
  Tenants: "Locatários",
  This_cannot_be_deleted_until_all_the_associated_requirements_and_sub_sections_are_removed_first:
    "Isto não pode ser excluído até que todos os requisitos e subseções associados sejam removidos primeiro.",
  This_cannot_be_deleted_until_all_the_associated_requirements_are_removed_first:
    "Isto não pode ser excluído até que todos os requisitos associados sejam removidos primeiro.",
  Version: "Versão",
  You_are_adding_a_new_requirement_to: "Você está adicionando um novo requisito para:",
} as const;
